import { CheckBox, FormInputGroupLayout, InputFormCallout, InputFormCalloutProps } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { MdsDeletionPolicyDetails } from "../../gen/clients/mchub-azure-api-client-mds";
import { MdsAutoBackupRetentionPolicy, MdsFinalBackupPolicy } from "../../helpers/resourceHelper";

export const enum Fields {
  DeleteProtected = "DeleteProtected",
  RequireFinalBackup = "RequireFinalBackup",
  RetainAutomaticBackups = "RetainAutomaticBackups",
}

export interface DeletionPlanEditCalloutProps extends
  Pick<InputFormCalloutProps, "title" | "targetId" | "onClose" | "onSubmit" | "componentRef">
{
  dbDelete?: MdsDeletionPolicyDetails;
}

export const DeletionPlanEditCallout = ({
  dbDelete,
  title,
  onClose,
  onSubmit,
  targetId,
  componentRef,
}: DeletionPlanEditCalloutProps): JSX.Element => (
  <InputFormCallout
    layout={FormInputGroupLayout.WIDE}
    title={title || ""}
    targetId={targetId}
    onClose={onClose}
    onSubmit={onSubmit}
    componentRef={componentRef}
  >
    <CheckBox
      fieldName={Fields.DeleteProtected}
      label={Messages.labels.mySQLDeleteProtected()}
      tooltip={Messages.hints.tooltipMySQLDeleteProtected()}
      defaultValue={dbDelete?.isDeleteProtected ?? false}
    />
    <CheckBox
      fieldName={Fields.RetainAutomaticBackups}
      label={Messages.labels.mySQLRetainAutomaticBackups()}
      tooltip={Messages.hints.tooltipMySQLRetainAutomaticBackups()}
      defaultValue={dbDelete?.automaticBackupRetention === MdsAutoBackupRetentionPolicy.RETAIN}
    />
    <CheckBox
      fieldName={Fields.RequireFinalBackup}
      label={Messages.labels.mySQLRequireFinalBackup()}
      tooltip={Messages.hints.tooltipMySQLRequireFinalBackup()}
      defaultValue={dbDelete?.finalBackup === MdsFinalBackupPolicy.REQUIRE_FINAL_BACKUP}
    />
  </InputFormCallout>
);
